import React, { useMemo } from 'react';
import { ENDODONTIC_ICONS } from '../../Helpers/endodontic/endodonticIcons';
import { Tooth, ToothEndodonticInput } from '../../../../graphql/graphql';
import DENTToothEndodonticIconSingle from './DENTToothEndodonticIconSingle';
import DENTToothEndodonticIconMultiple from './DENTToothEndodonticIconMultiple';

interface Props {
	reverse?: boolean;
	tooth: Tooth;
}

const DENTToothItemEndodonticIcon = ({ tooth, reverse }: Props) => {
	if (!(tooth.endodontic && Object.values(tooth.endodontic).find(Boolean))) {
		return <></>;
	}

	const activeIcons = useMemo(
		() =>
			Object.entries(tooth.endodontic || {})
				.filter(([_, value]) => value)
				.map(([key]) => ({
					key,
					icon: ENDODONTIC_ICONS[key as keyof ToothEndodonticInput],
				})),
		[tooth.endodontic],
	);

	if (activeIcons.length === 0) {
		return <></>;
	}

	if (activeIcons.length === 1) {
		return (
			<DENTToothEndodonticIconSingle
				iconData={activeIcons[0]}
				reverse={reverse}
			/>
		);
	}

	return (
		<DENTToothEndodonticIconMultiple iconData={activeIcons} reverse={reverse} />
	);
};

export default DENTToothItemEndodonticIcon;
